module.exports = __webpack_public_path__ + "img/b57f5c9.jpg";